export default function processSetValue(result, record, elementsByKey) {
  if (result.key.charAt(0) !== '@' && !!elementsByKey[result.key]) {
    record.form_values![result.key] = result.value;
  }
}
